import type { VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

import {
  InitializePronunciationGraderResponse,
  InitializePronunciationGraderResponseSchema,
} from '../types/pronunciation-grading-initialization.types.ts';

const INITIALIZE_PRONUNCIATION_GRADER_MUTATION = mutation({
  initializePronunciationGrader: [
    { input: input('input', 'InitializePronunciationGraderInput!') },
    {
      provider: true,
      metadata: true,
    },
  ],
});

type InitializePronunciationGraderInputType = VariablesOf<typeof INITIALIZE_PRONUNCIATION_GRADER_MUTATION>['input'];
type InitializePronunciationGraderResponseType = InitializePronunciationGraderResponse;

export const initializePronunciationGraderMutationRequest = async (
  props: InitializePronunciationGraderInputType
): Promise<ResultType<InitializePronunciationGraderResponseType>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.mutation(
    INITIALIZE_PRONUNCIATION_GRADER_MUTATION,
    { input: { ...props, metadata: JSON.stringify(props.metadata) } },
    { useAuth: true }
  );

  if (response?.initializePronunciationGrader) {
    return {
      success: true,
      data: InitializePronunciationGraderResponseSchema.parse({
        ...response.initializePronunciationGrader,
        metadata: JSON.parse(response.initializePronunciationGrader.metadata as string),
      }),
    };
  }

  return {
    success: false,
  };
};
